import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { useOnError } from 'shared/hooks/useOnError';

export function useQueryWithOnError<TData>(
  options: UseQueryOptions<TData, Error, TData, string[]>,
  title?: string
) {
  const query = useQuery({ ...options });
  useOnError({
    isError: query.isError,
    title,
    description: query.error?.message,
  });
  return query;
}
